import { render } from "./UsersPresence.vue?vue&type=template&id=1382fb03&scoped=true"
import script from "./UsersPresence.vue?vue&type=script&lang=js"
export * from "./UsersPresence.vue?vue&type=script&lang=js"

import "./UsersPresence.vue?vue&type=style&index=0&id=1382fb03&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1382fb03"]])

export default __exports__